var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "single container-max page-content" },
            [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-7 mt-5" },
                  [_vm._t("image-carousel")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-5 mt-md-5" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "stick-in-parent",
                          rawName: "v-stick-in-parent"
                        }
                      ]
                    },
                    [
                      _vm.currentVariation.filter.hasManufacturer
                        ? _c(
                            "div",
                            {
                              staticClass: "producertag h6 producer text-muted"
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.currentVariation.item.manufacturer
                                      .externalName
                                  ) +
                                  "\n                            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "h1",
                        {
                          staticClass: "h2 title",
                          attrs: { "data-testing": "item-name" }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm._f("itemName")(_vm.currentVariation)
                                ) +
                                "\n                                "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._t("tag-list"),
                      _vm._v(" "),
                      _vm.isShortDescriptionActive &&
                      _vm.currentVariation.texts.shortDescription !== ""
                        ? _c("p", {
                            staticClass: "single-description",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.shortDescription
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-5" }, [
                        _c(
                          "span",
                          { staticClass: "articlenumber small text-muted" },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemNumber"
                                  )
                                ) + " "
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.currentVariation.variation.number)
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.attributes.length || Object.keys(_vm.units).length
                        ? _c(
                            "div",
                            { staticClass: "mb-3" },
                            [_c("variation-select")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.variation.bundleType === "bundle"
                        ? _c("item-bundle", {
                            attrs: {
                              "bundle-type":
                                _vm.currentVariation.variation.bundleType,
                              "bundle-components":
                                _vm.currentVariation.bundleComponents
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("before-price"),
                      _vm._v(" "),
                      _vm.currentVariation.filter.isSalable &&
                      _vm.variationGroupedProperties.length
                        ? _c("div", [_c("order-property-list")], 1)
                        : _vm._e(),
                      _vm._v(" "),
                      _c("graduated-prices"),
                      _vm._v(" "),
                      _c("item-price", {
                        attrs: {
                          "show-cross-price": _vm.isRecommendedPriceActive
                        }
                      }),
                      _vm._v(" "),
                      _vm._t("after-price"),
                      _vm._v(" "),
                      _c("item-availability"),
                      _vm._v(" "),
                      _c("div", { staticClass: "my-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("before-add-to-basket")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.item.itemType === "set"
                          ? _c(
                              "div",
                              { staticClass: "alert alert-info w-100" },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemSetInfo"
                                      )
                                    ) +
                                    "\n                                "
                                )
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-sm-7 col-md-12 col-lg-8 my-3"
                              },
                              [
                                _c("add-to-basket", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id,
                                    "is-salable":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-children":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter
                                        .hasActiveChildren,
                                    "interval-quantity":
                                      _vm.currentVariation.variation
                                        .intervalOrderQuantity || 1,
                                    "minimum-quantity":
                                      _vm.currentVariation.variation
                                        .minimumOrderQuantity,
                                    "maximum-quantity":
                                      !!_vm.currentVariation.variation
                                        .maximumOrderQuantity &&
                                      _vm.currentVariation.variation
                                        .maximumOrderQuantity > 0
                                        ? _vm.currentVariation.variation
                                            .maximumOrderQuantity
                                        : null,
                                    "order-properties": _vm.currentVariation.properties.filter(
                                      function(prop) {
                                        return prop.property.isOderProperty
                                      }
                                    ),
                                    "use-large-scale": false,
                                    "show-quantity": true,
                                    "item-url": _vm._f("itemURL")(
                                      _vm.currentVariation
                                    ),
                                    "is-variation-selected":
                                      _vm.isVariationSelected &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-price": _vm._f("hasItemDefaultPrice")(
                                      _vm.currentVariation
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("after-add-to-basket")],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm._t("additional-content-after-add-to-basket"),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "vat small text-muted" },
                        [
                          _vm._v("\n                                * "),
                          _vm.showNetPrices
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemExclVAT"
                                    )
                                  )
                                )
                              ]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemInclVAT"
                                    )
                                  )
                                )
                              ],
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemExclusive"
                                )
                              ) +
                              "\n                            "
                          ),
                          _vm.hasShippingCostsCategoryId
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    "data-toggle": "modal",
                                    href: "#shippingscosts",
                                    title: _vm.$translate(
                                      "Ceres::Template.singleItemShippingCosts"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemShippingCosts"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _c(
                                "a",
                                {
                                  attrs: {
                                    title: _vm.$translate(
                                      "Ceres::Template.singleItemShippingCosts"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemShippingCosts"
                                      )
                                    )
                                  )
                                ]
                              )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._t("additional-content-after-vat")
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-7" }, [
                  _c("div", { staticClass: "my-5" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "nav nav-tabs",
                        attrs: { role: "tablist" }
                      },
                      [
                        _vm.isDescriptionTabActive
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link active",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href:
                                      "#details-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemDescription"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isTechnicalDataTabActive
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active:
                                      !_vm.isDescriptionTabActive &&
                                      _vm.isTechnicalDataTabActive
                                  },
                                  attrs: {
                                    "data-toggle": "tab",
                                    href:
                                      "#data-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemTechnicalData"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              class: {
                                active:
                                  !_vm.isDescriptionTabActive &&
                                  !_vm.isTechnicalDataTabActive
                              },
                              attrs: {
                                "data-toggle": "tab",
                                href: "#assessments-details",
                                role: "tab"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemMoreDetails"
                                  )
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._t("add-detail-tabs")
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tab-content overflow-hidden" },
                      [
                        _vm.isDescriptionTabActive
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane active overflow-auto",
                                attrs: {
                                  id:
                                    "details-" +
                                    _vm.currentVariation.variation.id,
                                  role: "tabpanel"
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "my-4",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.description
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isTechnicalDataTabActive
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane overflow-auto",
                                class: {
                                  active:
                                    !_vm.isDescriptionTabActive &&
                                    _vm.isTechnicalDataTabActive
                                },
                                attrs: {
                                  id:
                                    "data-" + _vm.currentVariation.variation.id,
                                  role: "tabpanel"
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "my-4",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.technicalData
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane overflow-auto",
                            class: {
                              active:
                                !_vm.isDescriptionTabActive &&
                                !_vm.isTechnicalDataTabActive
                            },
                            attrs: {
                              id: "assessments-details",
                              role: "tabpanel"
                            }
                          },
                          [
                            _c("div", { staticClass: "my-4" }, [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-striped table-hover table-sm"
                                },
                                [
                                  _c("tbody", [
                                    _vm.itemConfig.includes("item.id") ||
                                    _vm.itemConfig.includes("all")
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemId"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item.id
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.item.condition &&
                                    _vm.currentVariation.item.condition.names
                                      .name !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.condition"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemCondition"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .condition.names.name
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.itemConfig.includes(
                                      "item.age_rating"
                                    ) || _vm.itemConfig.includes("all")
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemAge"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("ageRestriction")(
                                                  _vm.currentVariation.item
                                                    .ageRestriction
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation
                                      .externalId !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.external_id"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemExternalVariationId"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .externalId
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation.model !==
                                      "" &&
                                    (_vm.itemConfig.includes(
                                      "item.variation_model"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemModel"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .model
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.filter
                                      .hasManufacturer &&
                                    _vm.currentVariation.item.manufacturer
                                      .externalName !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.manufacturer"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemManufacturer"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.externalName
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.item
                                      .producingCountry &&
                                    _vm.currentVariation.item.producingCountry
                                      .names.name !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.producerCountry"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemManufacturingCountry"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .producingCountry.names.name
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.unit &&
                                    (_vm.itemConfig.includes(
                                      "item.variationBase_content"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemContent"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.unit
                                                  .content
                                              ) +
                                                " " +
                                                _vm._s(
                                                  _vm.currentVariation.unit
                                                    .names.name
                                                )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation.weightG !==
                                      "" &&
                                    (_vm.itemConfig.includes("item.weightG") ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemWeight"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .weightG
                                              ) + " g"
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation
                                      .weightNetG !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.weightNetG"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemNetWeight"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .weightNetG
                                              ) + " g"
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.itemConfig.includes(
                                      "item.variation_dimensions"
                                    ) || _vm.itemConfig.includes("all")
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemDimensions"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .lengthMM
                                                )
                                              )
                                            ]),
                                            _vm._v("×"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .widthMM
                                                )
                                              )
                                            ]),
                                            _vm._v("×"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .heightMM
                                                )
                                              )
                                            ]),
                                            _vm._v(
                                              " mm\n                                                "
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation
                                      .customsTariffNumber !== "" &&
                                    (_vm.itemConfig.includes(
                                      "variation.customs_tariff_number"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemCustomsTariffNumber"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .customsTariffNumber
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._t("add-detail-tabs-content")
                      ],
                      2
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._t("item-list-container"),
              _vm._v(" "),
              _vm._t("feedback-container")
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }